import {makeAutoObservable} from 'mobx';

import {reactionsStore} from './reactions';
import {sentStore} from './sent';
import {FeaturesTabKey} from './types';
import {visitsStore} from './visits';

class FeaturesStore {
  reactions = reactionsStore;
  visits = visitsStore;
  sent = sentStore;

  private _lastActiveTab?: FeaturesTabKey;

  constructor() {
    makeAutoObservable(this, {
      reactions: false,
      visits: false,
      sent: false,
    });
  }

  get lastActiveTab() {
    return this._lastActiveTab;
  }

  setLastActiveTab(lastActiveTab: FeaturesTabKey | undefined) {
    this._lastActiveTab = lastActiveTab;
  }

  resetAllLists() {
    this.reactions.resetList();
    this.visits.resetList();
    this.sent.resetList();
  }

  resetReactionsAndVisits() {
    this.reactions.resetList();
    this.visits.resetList();
  }
}

export const featuresActivityStore = new FeaturesStore();
